import { HostCapacityTemplate } from 'types/GameHosting/template';

export const FETCH_HOST_TEMPLATE = 'FETCH_HOST_TEMPLATE';

export const FETCH_HOST_TEMPLATE_IS_PENDING = 'FETCH_HOST_TEMPLATE_IS_PENDING';

export const FETCH_HOST_TEMPLATE_IS_ERROR = 'FETCH_HOST_TEMPLATE_IS_ERROR';

export const FETCH_HOST_TEMPLATE_BY_ID = 'FETCH_HOST_TEMPLATE_BY_ID';

export const FETCH_HOST_TEMPLATE_BY_ID_IS_PENDING = 'FETCH_HOST_TEMPLATE_BY_ID_IS_PENDING';

export const FETCH_HOST_TEMPLATE_BY_ID_IS_ERROR = 'FETCH_HOST_TEMPLATE_BY_ID_IS_ERROR';

export const FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES = 'FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES';

export const FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_PENDING = 'FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_PENDING';

export const FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_ERROR = 'FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_ERROR';

export const CREATE_HOST_CAPACITY_TEMPLATE = 'CREATE_HOST_CAPACITY_TEMPLATE';

export const CREATE_HOST_CAPACITY_TEMPLATE_IS_PENDING = 'CREATE_HOST_CAPACITY_TEMPLATE_IS_PENDING';

export const CREATE_HOST_CAPACITY_TEMPLATE_IS_ERROR = 'CREATE_HOST_CAPACITY_TEMPLATE_IS_ERROR';

export const UPDATE_HOST_CAPACITY_TEMPLATE = 'UPDATE_HOST_CAPACITY_TEMPLATE';

export const UPDATE_HOST_CAPACITY_TEMPLATE_IS_PENDING = 'UPDATE_HOST_CAPACITY_TEMPLATE_IS_PENDING';

export const UPDATE_HOST_CAPACITY_TEMPLATE_IS_ERROR = 'UPDATE_HOST_CAPACITY_TEMPLATE_IS_ERROR';

export const DELETE_HOST_CAPACITY_TEMPLATE = 'DELETE_HOST_CAPACITY_TEMPLATE';

export const DELETE_HOST_CAPACITY_TEMPLATE_IS_PENDING = 'DELETE_HOST_CAPACITY_TEMPLATE_IS_PENDING';

export const DELETE_HOST_CAPACITY_TEMPLATE_IS_ERROR = 'DELETE_HOST_CAPACITY_TEMPLATE_IS_ERROR';

export const CREATE_HOST_CAPACITY_INSTANCE = 'CREATE_HOST_CAPACITY_INSTANCE';

export const CREATE_HOST_CAPACITY_INSTANCE_IS_PENDING = 'CREATE_HOST_CAPACITY_INSTANCE_IS_PENDING';

export const CREATE_HOST_CAPACITY_INSTANCE_IS_ERROR = 'CREATE_HOST_CAPACITY_INSTANCE_IS_ERROR';

export const UPDATE_HOST_CAPACITY_INSTANCE = 'UPDATE_HOST_CAPACITY_INSTANCE';

export const UPDATE_HOST_CAPACITY_INSTANCE_IS_PENDING = 'UPDATE_HOST_CAPACITY_INSTANCE_IS_PENDING';

export const UPDATE_HOST_CAPACITY_INSTANCE_IS_ERROR = 'UPDATE_HOST_CAPACITY_INSTANCE_IS_ERROR';

export const DELETE_HOST_CAPACITY_INSTANCE = 'DELETE_HOST_CAPACITY_INSTANCE';

export const DELETE_HOST_CAPACITY_INSTANCE_IS_PENDING = 'DELETE_HOST_CAPACITY_INSTANCE_IS_PENDING';

export const DELETE_HOST_CAPACITY_INSTANCE_IS_ERROR = 'DELETE_HOST_CAPACITY_INSTANCE_IS_ERROR';

export const CLEAN_ERROR = 'CLEAN_ERROR';

export const CANCEL_EDITION = 'CANCEL_EDITION';

export const SKIP_FETCH = 'SKIP_FETCH';

export const SORT = 'SORT_HOST_TEMPLATE';

export type HostTemplateReducer = {
  hostDepTemp: HostCapacityTemplate[];
  fetchIsCompleted: boolean;
  fetchIsPending: boolean;
  fetchIsError: null | boolean;
};
